import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setDairyHerdSize, setDairyHerdSizeAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_DAIRY_HERD_SIZE } from "consts";

import { FootprintingDairyHerdSize, UploadableHerdSize } from "models";

export const useMutateFootprintingDairyHerdSize = (primaryDataId: string, farmId: string, year: number) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation<FootprintingDairyHerdSize[], Error, UploadableHerdSize[]>({
    mutationKey: [FOOTPRINTING_DAIRY_HERD_SIZE, primaryDataId, isAdmin],
    mutationFn: (data) => (isAdmin ? setDairyHerdSizeAdmin(primaryDataId, data) : setDairyHerdSize(primaryDataId, data)),
    onSuccess: () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_DAIRY_HERD_SIZE, primaryDataId, isAdmin],
        ...footprintingDairyPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
      ]);
    },
  });
};
